import { byAlpha2 } from 'iso-country-codes';
import { CIVILITIES, COUNTRIES } from '@/constants/profile';
import { StringUtils } from '@/utils/StringUtils';

export const isSameUserAddress = (addr1 = {}, addr2 = {}) =>
  (addr1.id != null) && (addr1.id === addr2.id);

export const isAddressAlreadyExist = (user, addr) =>
  user.addresses.some((a) => a.addressName === addr.addressName && a.id !== addr.id);

export const getDefaultUserAddress = (user) => {
  let address;
  if (user && user.addresses) {
    const defaultAddress = user.addresses.find((a) => a.isDefault);
    address = defaultAddress ? defaultAddress : user.addresses[0];
  }
  return address;
};

export const findUserAddress = (user, id) =>
  user ? user.addresses.find((a) => a.id === id) : undefined;

export const saveUserAddress = (user, addr) => {
  let addresses;
  if (user && addr) {
    if (addr.id) {
      // Address already created => address modification
      addresses = user.addresses.map((a) => isSameUserAddress(a, addr) ? addr : a);
    } else if (!user.addresses.find((a) => a.addressName === addr.addressName)) {
      // New address and no other one with the same name
      addr = {
        ...addr,
        isDefault: user.addresses.length === 0
      };
      addresses = [
        ...user.addresses,
        addr
      ];
    }
  }
  return addresses;
};

export const getOnePhoneNumberFromCart = (address) => {
  address = address || {};
  return address.phoneNumberMobile || address.phoneNumber || address.phoneNumberWork || '';
};

export const setPhoneNumberInAddress = (addr) => {
  if (!addr.phoneNumberMobile || addr.phoneNumberMobile === '') {
    if (addr.phoneNumber && addr.phoneNumber !== '') {
      addr = {
        ...addr,
        phoneNumberMobile: addr.phoneNumber
      };
    } else if (addr.phoneNumberWork && addr.phoneNumberWork !== '') {
      addr = {
        ...addr,
        phoneNumberMobile: addr.phoneNumberWork
      };
    }
  }

  return addr;
};

export const getCivilityLabel = (t, civility, civilityOther) => civility ? (
  civility === CIVILITIES.OTHER && civilityOther ? StringUtils.capitalize(civilityOther) :
    Object.values(CIVILITIES).includes(civility) ? t(`forms.civility.${civility}`) :
      civility
) : '';

export const getCountryLabel = (country) => {
  const isoCountry = byAlpha2[country];
  return isoCountry ? isoCountry.name : '';
};

export const computeSiretOrIntracomNumberInputName = (country) => {
  if (country === COUNTRIES.FRANCE) {
    return 'siret';
  }

  return 'intracomNumber';
};

export const INTRACOM_COUNTRY_LIST_REQUIRED = [
  COUNTRIES.AUSTRIA,
  COUNTRIES.BELGIUM,
  COUNTRIES.GERMANY,
  COUNTRIES.GREECE,
  COUNTRIES.IRELAND,
  COUNTRIES.ITALY,
  COUNTRIES.LUXEMBOURG,
  COUNTRIES.NETHERLANDS,
  COUNTRIES.PORTUGAL,
  COUNTRIES.SPAIN
];

export const SIRET_COUNTRY_LIST_REQUIRED = [COUNTRIES.FRANCE];
